import SourceInstallPromptIOS from 'SourceComponent/InstallPromptIOS/InstallPromptIOS.component';

class InstallPromptIOS extends SourceInstallPromptIOS {
    renderCloseButton() {
        const { handleBannerClose } = this.props;

        return (
            <button
              block="InstallPromptIOS"
              elem="Close"
              onClick={ handleBannerClose }
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 21.999 21.999">
                    <path d="M12.215 10.999l9.533-9.533A.86.86 0 0020.532.251L11 9.784 1.467.251A.86.86 0 00.251 1.467l9.533 9.532-9.533 9.533a.86.86 0 001.215 1.215L11 12.215l9.533 9.533a.86.86 0 101.215-1.215z" />
                </svg>
            </button>
        );
    }

    renderHeading() {
        return (
            <p block="InstallPromptIOS" elem="Heading">
                { __('Install the app') }
            </p>
        );
    }

    renderContent() {
        return (
            <p block="InstallPromptIOS" elem="Content">
                <span>{ __('Tap:') }</span>
                <span block="InstallPromptIOS" elem="Share" />
                <span>{ __(', then') }</span>
                <span block="InstallPromptIOS" elem="Plus" />
                <span>{ __('add to homescreen') }</span>
            </p>
        );
    }

}

export default InstallPromptIOS;
